export const validSortOptions = ['alphabetical', 'match', 'usage'] as const;
export type SortOption = typeof validSortOptions[number];
export enum SortOptionKeys {
  SortOption = 'sort'
}
export type PackageSortOption = {
  [SortOptionKeys.SortOption]?: SortOption
}
